import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close'
import { Button, IconButton, OutlinedInput } from '@mui/material'
import like from '../assets/images/finchatGPT/like.png'
import dislike from '../assets/images/finchatGPT/dislike.png'
import { useState } from 'react'
import { Message } from '../assets/interfaces/interfaces'
import { AppDispatch } from '../redux/store'
import { useDispatch } from 'react-redux'
import { sendFeedback } from '../redux/slices/feedbacksSlice'
import { showNotification } from '../redux/slices/notificationSlice'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const style = {
  position: 'absolute' as 'absolute',
  top: '45%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
}

export default function FeedbackModal({
  open,
  onClose,
  isLiked,
  message,
}: {
  open: boolean
  onClose: any
  isLiked: boolean
  message?: Message | null
}) {
  const dispatch: AppDispatch = useDispatch();
  const handleClose = () => {
    onClose()
  }
  const [feedbackText, setFeedbackText] = useState('')
  const [showThankYou, setShowThankYou] = useState(false);
  const closeThankYouModal = () => setShowThankYou(false);
  async function sendResponse() {
    try {
      if (!!message) {
        const payload = {
          message_id: message.chat_id,
          is_thumbs_up: isLiked,
          feedback_text: feedbackText,
        }
        dispatch(sendFeedback(payload))
        if(isLiked) {
          setShowThankYou(true);
        } 
      }
    } catch (error) {
      console.log(`tradegpt-post-feedback ERROR: `, error)
    } finally {
      setFeedbackText('')
      handleClose()
    }

  }
  const ThankYouModal = () => (
    <Modal open={showThankYou} onClose={closeThankYouModal}>
      <Box sx={style} className="w-11/12 md:w-3/4 lg:w-2/3 max-w-4xl">
      <div className="flex flex-col gap-5">
          <div className="flex flex-row pb-6 justify-between border-b border-[#E4E5E8]">
            <div className="flex flex-row items-center gap-2 mt-2">
              <div>
                <img className="w-[35px]" src={isLiked ? like : dislike} alt="thumbs" />
              </div>
              <div className="text-[#1C1C1E] text-[18px] font-semibold leading-[24px] tracking-tighter">
                Thank you for the feedback
              </div>
            </div>
            <div>
              <IconButton size="small" onClick={closeThankYouModal}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div>
            <div className='text-black text-xl font-semibold mt-3'>
            Having a positive experience with TradeGPT so far?
            </div>
            <div className='text-black mt-4'>
            Leave us a review on TrustPilot and let others know about your experience.
            </div>
          </div>
          <div className="flex justify-end">
            <Button
              sx={{
                width: 'auto',
                p: 1,
                paddingTop: '9px',
                borderRadius: '8px',
                border: '1px solid #E4E5E8',
              }}
              onClick={() => {
                window.open('https://www.trustpilot.com/evaluate/tradealgo.com')
                closeThankYouModal();
              }}
              className="!text-[#1C1C1E] !font-inter !text-[14px] !font-semibold !leading-[18px] !tracking-tighter !normal-case"
              endIcon={<OpenInNewIcon />}
            >
              Leave Review
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );

  return (
    <>
    <Modal open={open} onClose={handleClose} aria-labelledby="feedback-modal">
      <Box sx={style} className="w-11/12 md:w-3/4 lg:w-2/3 max-w-4xl">
        <div className="flex flex-col gap-5">
          {/* top section */}
          <div className="flex flex-row pb-6 justify-between border-b border-[#E4E5E8]">
            <div className="flex flex-row items-center gap-2 mt-2">
              <div>
                <img className="w-[35px]" src={isLiked ? like : dislike} alt="thumbs" />
              </div>
              <div className="text-[#1C1C1E] font-inter text-[18px] font-semibold leading-[24px] tracking-tighter">
                Provide Additional Feedback
              </div>
            </div>
            <div>
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          {/* text area */}
          <div>
            <OutlinedInput
              multiline
              rows={3}
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
              className="w-full"
              placeholder={`What do you${isLiked ? '' : ' not'} like about this response?`}
            />
          </div>
          {/* submit button */}
          <div className="flex justify-end">
            <Button
              disabled={!feedbackText.length}
              sx={{
                width: '139px',
                p: 1,
                paddingTop: '9px',
                borderRadius: '8px',
                border: '1px solid #E4E5E8',
              }}
              onClick={sendResponse}
              className="!text-[#1C1C1E] !font-inter !text-[14px] !font-semibold !leading-[18px] !tracking-tighter !normal-case"
            >
              Submit Feedback
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
    <ThankYouModal/>
    </>
  )
}
